import { Link } from "react-router-dom";
import ClientLayout from "../components/ClientLayout.jsx";

export default function ClientAccessEmptyState({
  title,
  description,
  actionLabel = "Go to billing",
  actionTo = "/billing-settings",
  showAction = true,
}) {
  return (
    <ClientLayout>
      <section className="rounded-2xl border border-dashed border-hc-surface-border bg-hc-surface/60 px-6 py-16 text-center">
        <div className="mx-auto flex size-14 items-center justify-center rounded-full border border-hc-surface-border bg-hc-page-shell">
          <i className="icon-lock-closed text-xl text-hc-text-dim" aria-hidden="true" />
        </div>
        <h2 className="mt-4 text-lg font-semibold text-hc-text">
          {title ?? "Subscribe to get started"}
        </h2>
        <p className="mx-auto mt-2 max-w-md text-sm text-hc-text-dim">
          {description ??
            "Your coach has not activated your plan yet. Subscribe on the billing page to unlock programs and sessions."}
        </p>
        {showAction && (
          <Link
            to={actionTo}
            className="mt-6 inline-flex rounded-[10px] bg-hc-primary px-5 py-2.5 text-sm font-semibold text-white transition hover:opacity-90"
          >
            {actionLabel}
          </Link>
        )}
      </section>
    </ClientLayout>
  );
}
